import React from 'react';
import {Link} from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

import TelegramJoinButton from '../components/buttons/TelegramJoinButton'
import DiscordJoinButton from '../components/buttons/DiscordJoinButton'
import ShareButtons from './ShareButtons'
import GooglePlayButton from '../components/buttons/GooglePlayButton';
import AppStoreButton from '../components/buttons/AppStoreButton';

function Footer(){
  return (
    <div className="mt-2 pt-8">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center text-xs text-gray-500">
          {Capacitor.isNativePlatform() &&
            `The information in this app is for general information only. CryptoWaves.app is not a financial adviser. You should consider seeking independent legal, financial, taxation or other advice to check how the website information relates to your unique circumstances. CryptoWaves.app is not liable for any loss caused, whether due to negligence or otherwise arising from the use of, or reliance on, the information provided directly or indirectly, by use of this app.`
          }
          {!Capacitor.isNativePlatform() &&
            `The information on this website is for general information only. CryptoWaves.app is not a financial adviser. You should consider seeking independent legal, financial, taxation or other advice to check how the website information relates to your unique circumstances. CryptoWaves.app is not liable for any loss caused, whether due to negligence or otherwise arising from the use of, or reliance on, the information provided directly or indirectly, by use of this website.`
          }
        </div>

        <div className="mt-4 flex flex-col items-center gap-4">
          <TelegramJoinButton theme='dark'></TelegramJoinButton>
          {/*{!Capacitor.isNativePlatform() && 
            <div className="flex items-center gap-4">
              <GooglePlayButton size={30}></GooglePlayButton>
              <AppStoreButton size={30}></AppStoreButton>
            </div>
          }*/}
        </div>

      {/*<div className="col-12 text-center justify-content-center align-items-center my-2">
        <ShareButtons refer size={24} 
          media="https://cryptowaves-app.s3.us-east-2.amazonaws.com/heatmap.png"
          url={"https://www.cryptowaves.app"} 
          title={`Check This Crypto Market RSI Heatmap 🔥 Know What Coins To Buy or Sell Next 🚀 Get Crypto Market RSI 🚨 Alerts On Your Email & Telegram 👇
`}
          hashtags={['CryptoAlerts', 'CryptoMarket', 'cryptowaves']}
        >
        </ShareButtons>
      </div>*/}
        <div className="mt-4 text-center text-xs text-gray-500">
          <a className="footer-link" href="/blog/privacy">Privacy</a>
          <span className="mx-2 text-gray-400">•</span>
          <a className="footer-link" href="/blog/terms">Terms of Service</a>
          <span className="mx-2 text-gray-400">•</span>
          <a className="footer-link" href="/blog/support">Support</a>
        </div>
        <div className="pb-24 pt-4 text-center text-xs text-gray-500">
          © Est. 2021, CryptoWaves.App
        </div>
      </div>
    </div>
  );
};

export default Footer;
